import { render, staticRenderFns } from "./MarketViewEventsDayWidgetServer.vue?vue&type=template&id=a3bbbf78"
import script from "./MarketViewEventsDayWidgetServer.vue?vue&type=script&lang=js"
export * from "./MarketViewEventsDayWidgetServer.vue?vue&type=script&lang=js"
import style0 from "./MarketViewEventsDayWidgetServer.vue?vue&type=style&index=0&id=a3bbbf78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports